import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import { attributeValueDisplayText } from '../../../../../../Components/Attributes/Utils/AttributeValueUtils';
import { AvenyCollectionMap } from '../../../../../../Model/ModelContext/ModelContext';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import { AktivitetQuery_node_TEDBOAktivitet as IAktivitetNode } from '../Queries/_QueryTypes/AktivitetQuery';

interface IProps {
  data: IAktivitetNode | null | undefined;
  aktivitetModel: IClientBusinessModel;
  avenyCollectionMap: AvenyCollectionMap;
}

const AktivitetInfo = (props: IProps) => {
  return (
    <EDBox testID="info_card">
      {props?.data?._typ === 'BEGRAVNING' ? (
        <>
          <EDBox testID="info_avliden" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Avliden
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?._Associations?.Avlidna?._Associations?.Person?.Namn
                ? ` ${props?.data?._Associations?.Avlidna?._Associations?.Person?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Personnummer:
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Avlidna.Person.PERS_NR',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Avlidna?._Associations?.Person
                  ?.PERS_NR
              )}
            </EDTypography>

            <EDTypography>
              Dödsdatum:
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Avlidna.AVLIDEN_DATUM',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Avlidna?.AVLIDEN_DATUM
              )}
            </EDTypography>
            <EDTypography>
              Gravplats:
              {props?.data?._Associations?.Avlidna?._Associations?.KGard
                ?.KGARD &&
              props?.data?._Associations?.Avlidna?._Associations?.Kvarter
                ?.KVARTER &&
              props?.data?._Associations?.Avlidna?.GRAVNUMMER
                ? ` ${props?.data?._Associations?.Avlidna?._Associations?.KGard?.KGARD} ${props?.data?._Associations?.Avlidna?._Associations?.Kvarter?.KVARTER} ${props?.data?._Associations?.Avlidna?.GRAVNUMMER}`
                : props?.data?.GRAVPLATS
                ? ` ${props?.data?.GRAVPLATS}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_anhörig" sx={{ paddingBottom: 1 }}>
            <EDTypography
              testId="info_anhörig_title"
              variant="subtitle2"
              color={'black'}
            >
              Anhörig
              {props?.data?.BESTALLARE_TYP === 'ANHORIG'
                ? ' (Beställare)'
                : undefined}
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?.BESTALLARE_TYP === 'ANHORIG'
                ? props?.data?._Associations?.Bestallare?.Namn
                  ? ` ${props?.data?._Associations?.Bestallare?.Namn}`
                  : ' -'
                : props?.data?._Associations?.Anhorig?.NamnFE
                ? ` ${props?.data?._Associations?.Anhorig?.NamnFE}`
                : ' -'}
            </EDTypography>

            <EDTypography testId="info_anhörig_relation">
              Relation: {props?.data?.RELATION ? props?.data?.RELATION : '-'}
            </EDTypography>

            <EDTypography>
              Adress:
              {props?.data?.BESTALLARE_TYP === 'ANHORIG'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.ADRESS
                  ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.ADRESS}`
                  : ' -'
                : props?.data?._Associations?.Anhorig?.AdressRad
                ? ` ${props?.data?._Associations?.Anhorig?.AdressRad}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?.BESTALLARE_TYP === 'ANHORIG'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON1
                  ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON1}`
                  : ' -'
                : props?.data?._Associations?.Anhorig?._Associations?.Adress
                    ?.TELEFON1
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Arbetstelefon:
              {props?.data?._Associations?.Bestallare?._Associations?.Adress
                ?.TELEFON_ARB
                ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON_ARB}`
                : props?.data?._Associations?.Anhorig?._Associations?.Adress
                    ?.TELEFON_ARB
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.TELEFON_ARB}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mobiltelefon:
              {props?.data?._Associations?.Bestallare?._Associations?.Adress
                ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON_MOBIL}`
                : props?.data?._Associations?.Anhorig?._Associations?.Adress
                    ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.TELEFON_MOBIL}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Anhorig?._Associations?.Adress?.SMTP1
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_begravningsbyrå" sx={{ paddingBottom: 1 }}>
            <EDTypography
              testId="info_begravningsbyrå_title"
              variant="subtitle2"
              color={'black'}
            >
              Begravningsbyrå
              {props?.data?.BESTALLARE_TYP === 'BEGRAVNINGSBYRA'
                ? ' (Beställare)'
                : undefined}
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?.BESTALLARE_TYP === 'BEGRAVNINGSBYRA'
                ? props?.data?._Associations?.Bestallare?.Namn
                  ? ` ${props?.data?._Associations?.Bestallare?.Namn}`
                  : ' -'
                : props?.data?._Associations?.Begrbyra?.Namn
                ? ` ${props?.data?._Associations?.Begrbyra?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?.BESTALLARE_TYP === 'BEGRAVNINGSBYRA'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON1
                  ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON1}`
                  : ' -'
                : props?.data?._Associations?.Begrbyra?._Associations?.Adress
                    ?.TELEFON1
                ? ` ${props?.data?._Associations?.Begrbyra?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon 2:
              {props?.data?.BESTALLARE_TYP === 'BEGRAVNINGSBYRA'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON2
                  ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON2}`
                  : ' -'
                : props?.data?._Associations?.Begrbyra?._Associations?.Adress
                    ?.TELEFON2
                ? ` ${props?.data?._Associations?.Begrbyra?._Associations?.Adress?.TELEFON2}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Bestallare?._Associations?.Adress
                ?.SMTP1
                ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.SMTP1}`
                : props?.data?._Associations?.Anhorig?._Associations?.Adress
                    ?.SMTP1
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Kontaktperson:
              {props?.data?.BEGRBYRA_KONTAKT
                ? ` ${props?.data?.BEGRBYRA_KONTAKT}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon, kontakt:
              {props?.data?.BegrByraKontaktTelefon1
                ? ` ${props?.data?.BegrByraKontaktTelefon1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon 2, kontakt:
              {props?.data?.BegrByraKontaktTelefon2
                ? ` ${props?.data?.BegrByraKontaktTelefon2}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mobiltelefon, kontakt:
              {props?.data?.BegrByraKontaktMobil
                ? ` ${props?.data?.BegrByraKontaktMobil}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost, Kontakt:
              {props?.data?.BegrByraKontaktEpost
                ? ` ${props?.data?.BegrByraKontaktEpost}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_begravning" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Begravning
            </EDTypography>

            <EDTypography>
              Begravningstyp:
              {props?.data?._Associations?.Avlidna?.AKT_MED_URNA
                ? ' Akt med urna'
                : props?.data?.KREMERING === 'KREMERING'
                ? ' Kremering'
                : props?.data?.KREMERING === 'JORDBEGRAVNING'
                ? ' Jordbegravning'
                : ' -'}
            </EDTypography>

            <EDTypography>
              Begravningsordning:
              {props?.data?._Associations?.Begravningstyp?.BENAMNING
                ? ` ${props?.data?._Associations?.Begravningstyp?.BENAMNING}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_knutna_aktiviteter" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Knuten aktivitet/Knutna aktiviteter
            </EDTypography>

            {props?.data?._Associations?.KnutnaAktiviteter_All?.length
              ? props?.data?._Associations?.KnutnaAktiviteter_All?.map(item => (
                  <EDBox key={item.id}>
                    <EDTypography>
                      Aktivitetstyp:
                      {item?._Associations?.AktAkttyp?.NAMN
                        ? ` ${item?._Associations?.AktAkttyp?.NAMN}`
                        : '-'}
                    </EDTypography>

                    <EDTypography>
                      Titel: {item?.TITEL ? item?.TITEL : ' -'}
                    </EDTypography>

                    <EDTypography>
                      Datum: {item?.BOKNINGSDATUM ? item?.BOKNINGSDATUM : '-'}
                    </EDTypography>

                    <EDTypography>
                      Tid: {item?.FRANTID ? item?.FRANTID : '-'}-
                      {item?.TILLTID ? item?.TILLTID : '-'}
                    </EDTypography>

                    <EDTypography>
                      Plats:{' '}
                      {item?.Begravningsplats ? item?.Begravningsplats : '-'}
                    </EDTypography>

                    <EDTypography>
                      Bokad av:
                      {item?.BokadAv
                        ? ` ${item?.BokadAv}, ` + item?.BOKNINGSDATUM
                        : '-'}
                    </EDTypography>

                    <EDTypography sx={{ paddingBottom: 1 }}>
                      Senast ändrad:
                      {item.SenastAndrad ? ` ${item.SenastAndrad}` : '-'}
                    </EDTypography>
                  </EDBox>
                ))
              : ' -'}
          </EDBox>
        </>
      ) : props?.data?._typ === 'DOP' ? (
        <EDBox>
          <EDBox testID="info_dopkandidat" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Dopkandidat
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?._Associations?.Dopkandidat?.Namn
                ? ` ${props?.data?._Associations?.Dopkandidat?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Personnummer:{' '}
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Dopkandidat.PERS_NR',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Dopkandidat?.PERS_NR
              )}
            </EDTypography>

            <EDTypography>
              Adress:
              {props?.data?._Associations?.Dopkandidat?.AdressRad
                ? ` ${props?.data?._Associations?.Dopkandidat?.AdressRad}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?._Associations?.Dopkandidat?._Associations?.Adress
                ?.TELEFON1
                ? ` ${props?.data?._Associations?.Dopkandidat?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mob. tel:
              {props?.data?._Associations?.Dopkandidat?._Associations?.Adress
                ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Dopkandidat?._Associations?.Adress?.TELEFON_MOBIL}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Dopkandidat?._Associations?.Adress
                ?.SMTP1
                ? ` ${props?.data?._Associations?.Dopkandidat?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox sx={{ paddingBottom: 1 }}>
            <EDTypography
              testId="info_vardnadshavare_one"
              variant="subtitle2"
              color={'black'}
            >
              Vårdnadshavare 1{' '}
              {props?.data?.BESTALLARE_TYP === 'VARDNADSHAVARE_1'
                ? ' (Beställare)'
                : undefined}
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?._Associations?.Moder?.Namn
                ? ` ${props?.data?._Associations?.Moder?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Personnummer:{' '}
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Moder.PERS_NR',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Moder?.PERS_NR
              )}
            </EDTypography>

            <EDTypography>
              Adress:
              {props?.data?._Associations?.Moder?.AdressRad
                ? ` ${props?.data?._Associations?.Moder?.AdressRad}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?._Associations?.Moder?._Associations?.Adress
                ?.TELEFON1
                ? ` ${props?.data?._Associations?.Moder?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Arb. tel:
              {props?.data?._Associations?.Moder?._Associations?.Adress
                ?.TELEFON_ARB
                ? ` ${props?.data?._Associations?.Moder?._Associations?.Adress?.TELEFON_ARB}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mob. tel:
              {props?.data?._Associations?.Moder?._Associations?.Adress
                ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Moder?._Associations?.Adress?.TELEFON_MOBIL}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Moder?._Associations?.Adress?.SMTP1
                ? ` ${props?.data?._Associations?.Moder?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_vardnadshavare_two" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Vårdnadshavare 2{' '}
              {props?.data?.BESTALLARE_TYP === 'VARDNADSHAVARE_2'
                ? ' (Beställare)'
                : undefined}
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?._Associations?.Fader?.Namn
                ? ` ${props?.data?._Associations?.Fader?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Personnummer:{' '}
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Fader.PERS_NR',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Fader?.PERS_NR
              )}
            </EDTypography>

            <EDTypography>
              Adress:
              {props?.data?._Associations?.Fader?.AdressRad
                ? ` ${props?.data?._Associations?.Fader?.AdressRad}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?._Associations?.Fader?._Associations?.Adress
                ?.TELEFON1
                ? ` ${props?.data?._Associations?.Fader?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Arb. tel:
              {props?.data?._Associations?.Fader?._Associations?.Adress
                ?.TELEFON_ARB
                ? ` ${props?.data?._Associations?.Fader?._Associations?.Adress?.TELEFON_ARB}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mob. tel:
              {props?.data?._Associations?.Fader?._Associations?.Adress
                ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Fader?._Associations?.Adress?.TELEFON_MOBIL}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Fader?._Associations?.Adress?.SMTP1
                ? ` ${props?.data?._Associations?.Fader?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>
          </EDBox>
        </EDBox>
      ) : props?.data?._typ === 'VIGSEL' ? (
        <EDBox>
          <EDBox sx={{ paddingBottom: 1 }}>
            <EDTypography
              testId="info_person_one"
              variant="subtitle2"
              color={'black'}
            >
              Person 1{' '}
              {props?.data?.BESTALLARE_TYP === 'PERSON_1'
                ? ' (Beställare)'
                : undefined}
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?._Associations?.Brud?.Namn
                ? ` ${props?.data?._Associations?.Brud?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Personnummer:{' '}
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Brud.PERS_NR',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Brud?.PERS_NR
              )}
            </EDTypography>

            <EDTypography>
              Adress:
              {props?.data?._Associations?.Brud?.AdressRad
                ? ` ${props?.data?._Associations?.Brud?.AdressRad}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?._Associations?.Brud?._Associations?.Adress?.TELEFON1
                ? ` ${props?.data?._Associations?.Brud?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Arb. tel:
              {props?.data?._Associations?.Brud?._Associations?.Adress
                ?.TELEFON_ARB
                ? ` ${props?.data?._Associations?.Brud?._Associations?.Adress?.TELEFON_ARB}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mob. tel:
              {props?.data?._Associations?.Brud?._Associations?.Adress
                ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Brud?._Associations?.Adress?.TELEFON_MOBIL}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Brud?._Associations?.Adress?.SMTP1
                ? ` ${props?.data?._Associations?.Brud?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox sx={{ paddingBottom: 1 }}>
            <EDTypography
              testId="info_person_two"
              variant="subtitle2"
              color={'black'}
            >
              Person 2{' '}
              {props?.data?.BESTALLARE_TYP === 'PERSON_2'
                ? ' (Beställare)'
                : undefined}
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?._Associations?.Brudgum?.Namn
                ? ` ${props?.data?._Associations?.Brudgum?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Personnummer:{' '}
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Brudgum.PERS_NR',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Brudgum?.PERS_NR
              )}
            </EDTypography>

            <EDTypography>
              Adress:
              {props?.data?._Associations?.Brudgum?.AdressRad
                ? ` ${props?.data?._Associations?.Brudgum?.AdressRad}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?._Associations?.Brudgum?._Associations?.Adress
                ?.TELEFON1
                ? ` ${props?.data?._Associations?.Brudgum?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Arb. tel:
              {props?.data?._Associations?.Brudgum?._Associations?.Adress
                ?.TELEFON_ARB
                ? ` ${props?.data?._Associations?.Brudgum?._Associations?.Adress?.TELEFON_ARB}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mob. tel:
              {props?.data?._Associations?.Brudgum?._Associations?.Adress
                ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Brudgum?._Associations?.Adress?.TELEFON_MOBIL}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Brudgum?._Associations?.Adress?.SMTP1
                ? ` ${props?.data?._Associations?.Brudgum?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>
          </EDBox>
        </EDBox>
      ) : props?.data?._typ === 'GRAVSATTNING' ? (
        <EDBox>
          <EDBox testID="info_avliden" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Avliden
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?._Associations?.Avlidna?._Associations?.Person?.Namn
                ? ` ${props?.data?._Associations?.Avlidna?._Associations?.Person?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Personnummer:
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Avlidna.Person.PERS_NR',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Avlidna?._Associations?.Person
                  ?.PERS_NR
              )}
            </EDTypography>

            <EDTypography>
              Dödsdatum:
              {attributeValueDisplayText(
                props?.aktivitetModel,

                'Avlidna.AVLIDEN_DATUM',

                props?.avenyCollectionMap,

                props?.data?._Associations?.Avlidna?.AVLIDEN_DATUM
              )}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_begravning" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Begravning
            </EDTypography>

            <EDTypography>
              Begravningstyp:
              {props?.data?._Associations?.Avlidna?.AKT_MED_URNA
                ? ' Akt med urna'
                : props?.data?.KREMERING === 'KREMERING'
                ? ' Kremering'
                : props?.data?.KREMERING === 'JORDBEGRAVNING'
                ? ' Jordbegravning'
                : ' -'}
            </EDTypography>

            <EDTypography>
              Begravningsordning:
              {props?.data?._Associations?.Begravningstyp?.BENAMNING
                ? ` ${props?.data?._Associations?.Begravningstyp?.BENAMNING}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_gravplats" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Gravsättning
            </EDTypography>

            <EDTypography>
              {props?.data?._Associations?.Avlidna?.AKT_MED_URNA
                ? 'Akt med urna'
                : props?.data?.KREMERING === 'KREMERING'
                ? props?.data?.MINNESLUND
                  ? 'Minneslund'
                  : props?.data?.ASKGRAVLUND
                  ? 'Askgravlund'
                  : props?.data?.URNSATTNING
                  ? 'Urnsättning'
                  : 'Kremering'
                : props?.data?.KREMERING === 'JORDBEGRAVNING'
                ? 'Jordbegravning'
                : '-'}
            </EDTypography>

            <EDTypography>
              Kyrkogård:
              {props?.data?._Associations?.Avlidna?._Associations?.KGard
                ?.BENAMNING
                ? ` ${props?.data?._Associations?.Avlidna?._Associations?.KGard?.BENAMNING}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Gravplats:
              {props?.data?._Associations?.Avlidna?._Associations?.KGard
                ?.KGARD &&
              props?.data?._Associations?.Avlidna?._Associations?.Kvarter
                ?.KVARTER &&
              props?.data?._Associations?.Avlidna?.GRAVNUMMER
                ? ` ${props?.data?._Associations?.Avlidna?._Associations?.KGard?.KGARD} ${props?.data?._Associations?.Avlidna?._Associations?.Kvarter?.KVARTER} ${props?.data?._Associations?.Avlidna?.GRAVNUMMER}`
                : props?.data?.GRAVPLATS
                ? ` ${props?.data?.GRAVPLATS}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_anhörig" sx={{ paddingBottom: 1 }}>
            <EDTypography
              testId="info_anhörig_title"
              variant="subtitle2"
              color={'black'}
            >
              Anhörig
              {props?.data?.BESTALLARE_TYP === 'ANHORIG'
                ? ' (Beställare)'
                : undefined}
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?.BESTALLARE_TYP === 'ANHORIG'
                ? props?.data?._Associations?.Bestallare?.Namn
                  ? ` ${props?.data?._Associations?.Bestallare?.Namn}`
                  : ' -'
                : props?.data?._Associations?.Anhorig?.NamnFE
                ? ` ${props?.data?._Associations?.Anhorig?.NamnFE}`
                : ' -'}
            </EDTypography>

            <EDTypography testId="info_anhörig_relation">
              Relation: {props?.data?.RELATION ? props?.data?.RELATION : '-'}
            </EDTypography>

            <EDTypography>
              Adress:
              {props?.data?.BESTALLARE_TYP === 'ANHORIG'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.ADRESS
                  ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.ADRESS}`
                  : ' -'
                : props?.data?._Associations?.Anhorig?.AdressRad
                ? ` ${props?.data?._Associations?.Anhorig?.AdressRad}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?.BESTALLARE_TYP === 'ANHORIG'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON1
                  ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON1}`
                  : ' -'
                : props?.data?._Associations?.Anhorig?._Associations?.Adress
                    ?.TELEFON1
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Arbetstelefon:
              {props?.data?._Associations?.Bestallare?._Associations?.Adress
                ?.TELEFON_ARB
                ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON_ARB}`
                : props?.data?._Associations?.Anhorig?._Associations?.Adress
                    ?.TELEFON_ARB
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.TELEFON_ARB}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mobiltelefon:
              {props?.data?._Associations?.Bestallare?._Associations?.Adress
                ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON_MOBIL}`
                : props?.data?._Associations?.Anhorig?._Associations?.Adress
                    ?.TELEFON_MOBIL
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.TELEFON_MOBIL}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Anhorig?._Associations?.Adress?.SMTP1
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_begravningsbyrå" sx={{ paddingBottom: 1 }}>
            <EDTypography
              testId="info_begravningsbyrå_title"
              variant="subtitle2"
              color={'black'}
            >
              Begravningsbyrå
              {props?.data?.BESTALLARE_TYP === 'BEGRAVNINGSBYRA'
                ? ' (Beställare)'
                : undefined}
            </EDTypography>

            <EDTypography>
              Namn:
              {props?.data?.BESTALLARE_TYP === 'BEGRAVNINGSBYRA'
                ? props?.data?._Associations?.Bestallare?.Namn
                  ? ` ${props?.data?._Associations?.Bestallare?.Namn}`
                  : ' -'
                : props?.data?._Associations?.Begrbyra?.Namn
                ? ` ${props?.data?._Associations?.Begrbyra?.Namn}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon:
              {props?.data?.BESTALLARE_TYP === 'BEGRAVNINGSBYRA'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON1
                  ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON1}`
                  : ' -'
                : props?.data?._Associations?.Begrbyra?._Associations?.Adress
                    ?.TELEFON1
                ? ` ${props?.data?._Associations?.Begrbyra?._Associations?.Adress?.TELEFON1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon 2:
              {props?.data?.BESTALLARE_TYP === 'BEGRAVNINGSBYRA'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON2
                  ? ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON2}`
                  : ' -'
                : props?.data?._Associations?.Begrbyra?._Associations?.Adress
                    ?.TELEFON2
                ? ` ${props?.data?._Associations?.Begrbyra?._Associations?.Adress?.TELEFON2}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost:
              {props?.data?._Associations?.Begrbyra?._Associations?.Adress
                ?.SMTP1
                ? ` ${props?.data?._Associations?.Begrbyra?._Associations?.Adress?.SMTP1}`
                : props?.data?._Associations?.Anhorig?._Associations?.Adress
                    ?.SMTP1
                ? ` ${props?.data?._Associations?.Anhorig?._Associations?.Adress?.SMTP1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Kontaktperson:
              {props?.data?.BEGRBYRA_KONTAKT
                ? ` ${props?.data?.BEGRBYRA_KONTAKT}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon, kontakt:
              {props?.data?.BegrByraKontaktTelefon1
                ? ` ${props?.data?.BegrByraKontaktTelefon1}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Telefon 2, kontakt:
              {props?.data?.BegrByraKontaktTelefon2
                ? ` ${props?.data?.BegrByraKontaktTelefon2}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Mobiltelefon, kontakt:
              {props?.data?.BegrByraKontaktMobil
                ? ` ${props?.data?.BegrByraKontaktMobil}`
                : ' -'}
            </EDTypography>

            <EDTypography>
              Epost, Kontakt:
              {props?.data?.BegrByraKontaktEpost
                ? ` ${props?.data?.BegrByraKontaktEpost}`
                : ' -'}
            </EDTypography>
          </EDBox>

          <EDBox testID="info_knutna_aktiviteter" sx={{ paddingBottom: 1 }}>
            <EDTypography variant="subtitle2" color={'black'}>
              Knuten aktivitet/Knutna aktiviteter
            </EDTypography>

            {props?.data?._Associations?.KnutnaAktiviteter_All?.length
              ? props?.data?._Associations?.KnutnaAktiviteter_All?.map(item => (
                  <EDBox key={item.id}>
                    <EDTypography>
                      Aktivitetstyp:
                      {item?._Associations?.AktAkttyp?.NAMN
                        ? ` ${item?._Associations?.AktAkttyp?.NAMN}`
                        : '-'}
                    </EDTypography>

                    <EDTypography>
                      Titel: {item?.TITEL ? item?.TITEL : ' -'}
                    </EDTypography>

                    <EDTypography>
                      Datum: {item?.BOKNINGSDATUM ? item?.BOKNINGSDATUM : '-'}
                    </EDTypography>

                    <EDTypography>
                      Tid: {item?.FRANTID ? item?.FRANTID : '-'}-
                      {item?.TILLTID ? item?.TILLTID : '-'}
                    </EDTypography>

                    <EDTypography>
                      Plats:{' '}
                      {item?.Begravningsplats ? item?.Begravningsplats : '-'}
                    </EDTypography>

                    <EDTypography>
                      Bokad av:
                      {item?.BokadAv
                        ? ` ${item?.BokadAv}, ` + item?.BOKNINGSDATUM
                        : '-'}
                    </EDTypography>

                    <EDTypography sx={{ paddingBottom: 1 }}>
                      Senast ändrad:
                      {item.SenastAndrad ? ` ${item.SenastAndrad}` : '-'}
                    </EDTypography>
                  </EDBox>
                ))
              : ' -'}
          </EDBox>
        </EDBox>
      ) : props?.data?._typ === 'KONFIRMATION' ? (
        <EDBox>
          <EDTypography>Konfirmation</EDTypography>
        </EDBox>
      ) : props?.data?._typ === 'LOKALUTHYRNING' ? (
        <EDBox>
          <EDTypography variant="subtitle2" color={'black'}>
            Beställare:
          </EDTypography>
          {props?.data?._Associations?.Bestallare?.Namn && (
            <EDTypography>
              Namn:{' '}
              {props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON'
                ? props?.data?._Associations?.Bestallare?.Namn
                : ` ${props?.data?._Associations?.Bestallare?.Namn}`}
            </EDTypography>
          )}
          {props?.data?._Associations?.Bestallare?._Associations?.Adress?.CO &&
            props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON' && (
              <EDTypography>
                C/O:{' '}
                {props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON'
                  ? props?.data?._Associations?.Bestallare?._Associations
                      ?.Adress?.CO
                  : `${props?.data?._Associations?.Bestallare?._Associations?.Adress?.CO}`}
              </EDTypography>
            )}

          {props?.data?.BEGRBYRA_KONTAKT && (
            <EDTypography>
              Kontakt:
              {` ${props?.data?.BEGRBYRA_KONTAKT}`}
            </EDTypography>
          )}
          {props?.data?.BESTALLARE_KONTAKT && (
            <EDTypography>
              Kontakt:
              {` ${props?.data?.BESTALLARE_KONTAKT}`}
            </EDTypography>
          )}

          {props?.data?._Associations?.Bestallare?._Associations?.Adress
            ?.ADRESS && (
            <EDTypography>
              Adress:
              {` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.ADRESS}`}
              {props?.data?._Associations?.Bestallare?._Associations?.Adress
                ?.POSTNR &&
                `, ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.POSTNR}`}
              {props?.data?._Associations?.Bestallare?._Associations?.Adress
                ?.ORT &&
                ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.ORT}`}
              {props?.data?._Associations?.Bestallare?._Associations?.Adress
                ?._Associations?.Land?.BENAMNING &&
                `, ${props?.data?._Associations?.Bestallare?._Associations?.Adress?._Associations?.Land?.BENAMNING}`}
            </EDTypography>
          )}

          {props?.data?._Associations?.Bestallare?._Associations?.Adress
            ?.TELEFON1 && (
            <EDTypography>
              Telefon:{' '}
              {props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON1
                : ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON1}`}
            </EDTypography>
          )}

          {props?.data?._Associations?.Bestallare?._Associations?.Adress
            ?.TELEFON2 && (
            <EDTypography>
              Telefon2:
              {props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON2
                : ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON2}`}
            </EDTypography>
          )}
          {props?.data?._Associations?.Bestallare?._Associations?.Adress
            ?.TELEFON_ARB && (
            <EDTypography>
              Arb tel:{' '}
              {props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON_ARB
                : ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON_ARB}`}
            </EDTypography>
          )}
          {props?.data?._Associations?.Bestallare?._Associations?.Adress
            ?.TELEFON_MOBIL && (
            <EDTypography>
              Mob tel:{' '}
              {props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.TELEFON_MOBIL
                : ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.TELEFON_MOBIL}`}
            </EDTypography>
          )}
          {props?.data?._Associations?.Bestallare?._Associations?.Adress
            ?.SMTP1 && (
            <EDTypography>
              E-post:{' '}
              {props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON'
                ? props?.data?._Associations?.Bestallare?._Associations?.Adress
                    ?.SMTP1
                : ` ${props?.data?._Associations?.Bestallare?._Associations?.Adress?.SMTP1}`}
            </EDTypography>
          )}
          {props?.data?.BESTALLARE_KONTAKT_INFO && (
            <EDTypography>
              Kontaktinfo:
              {props?.data?.BESTALLARE_TYP === 'ANNAN_PERSON'
                ? props?.data?.BESTALLARE_KONTAKT_INFO
                : ` ${props?.data?.BESTALLARE_KONTAKT_INFO}`}
            </EDTypography>
          )}
        </EDBox>
      ) : undefined}
    </EDBox>
  );
};

export default AktivitetInfo;
